import {
  default as socialNetworkFrameService,
  SocialNetworkFrameService,
} from '@agent/agent-interface/contact-view/social-network/services/social-network-frame.service';
import {
  default as socialNetworkTabService,
  SocialNetworkTabService,
} from '@agent/agent-interface/contact-view/social-network/services/social-network-tab.service';
import { module } from 'angular';

import { default as socialNetworkServiceName, SocialNetworkService } from './social-network.service';

export default module('contact.agent.core.channel-digit.social-network', [])
  .run([socialNetworkServiceName, () => {}])
  .service(socialNetworkServiceName, SocialNetworkService)
  .service(socialNetworkTabService, SocialNetworkTabService)
  .service(socialNetworkFrameService, SocialNetworkFrameService).name;
